import React, { useState } from 'react'
import { Tab, Row, Nav } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useRouteMatch, Switch, Route } from 'react-router-dom'
import {
  getUserModuleActions,
  getUserSubModuleActions,
} from '../../../../store/user/selectors'
import { checkPermission } from '../../../../utils/utilFunctions'
import SrtApplication from './SrtApplication'
import SrtFileView from './SrtFileView'
import SrtReturn from './SrtReturn'

const Srt = () => {
  const { path } = useRouteMatch()

  const [selectedSection, setSelectedSection] = useState('srt')

  const actionListModule = useSelector(
    getUserModuleActions('compensation-certification', 'loan', 'srt')
  )

  const actionListSubModule = useSelector(
    getUserSubModuleActions(
      'compensation-certification',
      'loan',
      'srt',
      'file-return'
    )
  )
  return (
    <Switch>
      <Route path={`${path}/`} exact>
        <Tab.Container id="left-tabs-example" defaultActiveKey="srt">
          <Row className="tab-page-layout">
            <Nav variant="pills" className="flex-row">
              {checkPermission('view', actionListModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('srt')
                    }}
                    eventKey="srt"
                  >
                    SRT Application
                  </Nav.Link>
                </Nav.Item>
              )}
              {checkPermission('view', actionListSubModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('srt-return')
                    }}
                    eventKey="srt-return"
                  >
                    SRT Return
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>
          </Row>
          <Row className="page-tiles-layout align-content-start">
            {selectedSection === 'srt' ? (
              <>
                {checkPermission('view', actionListModule) && (
                  <SrtApplication />
                )}
              </>
            ) : (
              <>
                {checkPermission('view', actionListSubModule) && <SrtReturn />}
              </>
            )}
          </Row>
        </Tab.Container>
      </Route>
      <Route
        path={`${path}/view/:id`}
        render={(props) => <SrtFileView type="view" {...props} />}
      />
      <Route
        path={`${path}/return/:id`}
        render={(props) => <SrtFileView type="file-return" {...props} />}
      />
    </Switch>
  )
}

export default Srt
